/**
 * 时间组件
 * zxw
 * 2024-08-09
 */
import React , { useState, useEffect } from 'react';

const x = ["星期日","星期一","星期二","星期三","星期四","星期五","星期六"];

const Time = () => {
    const [week, setWeek] = useState('');
    const [time, setTime] = useState('');

    useEffect(() => {
        setInterval(() => {
            let today = new Date();
            let time = today.getFullYear() + '年' 
            time += (today.getMonth() + 1) + '月' 
            time += today.getDate() + '日 ' 
            time += today.getHours()<10?('0' + today.getHours()):today.getHours()
            time += ':' + (today.getMinutes()<10?('0' + today.getMinutes()):today.getMinutes()) + ':'
            time += today.getSeconds()<10?('0' + today.getSeconds()):today.getSeconds()
            let week = x[today.getDay()];
            setWeek(week);
            setTime(time);
        }, 1000);
    }, [])

    return <span>{week}，{time}</span>;
}


// class Node extends Component{
//     constructor(props){
//         super(props);
//         this.state = {
//             time: '',
//             week: '',
//         }
//     }

//     componentDidUpdate(){
//         const _this = this;
//         setTimeout(function() {  
//             let today = new Date();
//             let time = today.getFullYear() + '年' 
//             time += (today.getMonth() + 1) + '月' 
//             time += today.getDate() + '日 ' 
//             time += today.getHours()<10?('0' + today.getHours()):today.getHours()
//             time += ':' + (today.getMinutes()<10?('0' + today.getMinutes()):today.getMinutes()) + ':'
//             time += today.getSeconds()<10?('0' + today.getSeconds()):today.getSeconds()
//             let week = x[today.getDay()];
//             _this.setState({
//                 time: time,
//                 week: week,
//             });
//         }, 0);
//     }

//     render(){
//         return <span>{this.state.week}，{this.state.time}</span>;
//     }
// }
export default Time;